
import { Component } from '@angular/core';
import { SigninService } from '../../services/signin.service';
import { AlertService } from '../../providers/alert.service';
import { SigninPage } from '../signin/signin';
import { NavController } from 'ionic-angular';
import { StorageService } from '../../providers/storage.service';
import { CommonService } from '../../services/common.service';
import { WechatSettingModel } from '../../models/wechat.model';
import { AppConfig } from '../../app/app.config';

@Component({
    selector: 'wechat',
    templateUrl: 'wechatunbind.html',
    providers: [

    ]
})

export class WechatUnBindPage {
    wechatSettings: WechatSettingModel;
    recode: string = "";
    state: string = "";

    constructor(
        private navCtrl: NavController,
        private signinService: SigninService,
        private alert: AlertService,
        private localStorage: StorageService,
        private common: CommonService,
        private appConfig: AppConfig
    ) {
        this.recode = "";
        this.wechatSettings = new WechatSettingModel();
    }

    ionViewDidLoad() {
        this.state = this.common.getParam("state");
        this.recode = this.common.getParam("code");
        this.wechatSettings = this.appConfig.GetWechatSettings();
        if (!this.wechatSettings) {
            this.wechatoAuth();
        } else {
            this.jumpWechatUrl();
        }
    }

    wechatoAuth() {
        this.common.oAuth().then((res: WechatSettingModel) => {
            if (res) {
                this.wechatSettings = res;
                this.localStorage.write("wechatsettings", this.wechatSettings);
            } else {
                this.navCtrl.push(SigninPage);
            }
        }).then(() => {
            this.jumpWechatUrl();
        }).catch((err) => {
            document.getElementById("errorMessage").innerHTML = err;
        })
    }


    jumpWechatUrl() {
        if (!this.state) {
            this.state = new Date().getTime() + "";
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="
                + this.wechatSettings.WxAppID + "&redirect_uri="
                + this.wechatSettings.WapJumpUrl + "&response_type=code&scope=snsapi_userinfo&state="
                + this.state + "#wechat_redirect";
        } else {
            this.wxUnBind(this.recode, this.state);
        }
    }

    wxUnBind(code, state) {
        state = this.localStorage.readString("unwxbinding");
        this.signinService.getWechatUnBind(code, state).then(s => {
            this.alert.alert({
                title: "微信解绑成功！",
                buttons: [{
                    text: "确认",
                    handler: () => {
                        this.navCtrl.push(SigninPage);
                    }
                }]
            })
        }).catch(err => {
            this.alert.alert({
                title: JSON.parse(err._body).ExceptionMessage,
                buttons: [{
                    text: "确认",
                    handler: () => {
                        this.navCtrl.push(SigninPage);
                    }
                }]
            })
        })
        this.localStorage.remove("unwxbinding");
    }
}



// WEBPACK FOOTER //
// ./src/pages/wechat/wechatunbind.ts